import React from 'react';
import { Box, Stack, Grid, Paper, Typography, Avatar } from '@mui/material';
import { Star } from 'lucide-react';
import { Question } from '../../../Interfaces';

interface IStarScore {
  breakdown: NonNullable<Question['starBreakdown']>;
}

export const StarScore: React.FC<IStarScore> = ({ breakdown }) => {
  const starData = [
    {
      key: 'situation',
      label: 'Situation',
      letter: 'S',
      color: '#9c27b0',
      value: breakdown.situation,
    },
    {
      key: 'task',
      label: 'Task',
      letter: 'T',
      color: '#1976d2',
      value: breakdown.task,
    },
    {
      key: 'actions',
      label: 'Actions',
      letter: 'A',
      color: '#2e7d32',
      value: breakdown.actions,
    },
    {
      key: 'results',
      label: 'Results',
      letter: 'R',
      color: '#ed6c02',
      value: breakdown.results,
    },
  ];

  return (
    <Box sx={{ px: 1.5, py: 1 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Star size={14} color="#fbc02d" fill="#fbc02d" />
        <Typography variant="caption" fontWeight={700} color="text.secondary">
          STAR Analysis
        </Typography>
      </Stack>
      <Grid container spacing={1}>
        {starData.map((item) => {
          const percentage = Math.round(
            (item.value.score / item.value.total) * 100,
          );

          return (
            <Grid item xs={3} key={item.key}>
              <Paper
                variant="outlined"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 0.5,
                  p: 1,
                  borderRadius: 1.5,
                  textAlign: 'center',
                  '&:hover': { bgcolor: 'action.hover' },
                }}
              >
                <Avatar
                  variant="rounded"
                  sx={{
                    width: 28,
                    height: 28,
                    bgcolor: item.color,
                    fontSize: 12,
                    fontWeight: 700,
                  }}
                >
                  {item.letter}
                </Avatar>
                <Typography variant="caption" fontWeight={700}>
                  {percentage}%
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                  {item.value.score}/{item.value.total}
                </Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
